import React, { useState } from "react";
import "./QualityAssurance.scss";
import qualityAssuranceBanner from "../../../../Assets/Red_Theme/services/details/qualityAssuranceBanner.png";
import QuoteModal from "../../../../Components/QuoteModal";
import testingPhaseBanner from "../../../../Assets/Red_Theme/services/details/testingPhaseBanner.png";
import systemsPlatforms from "../../../../Assets/Red_Theme/services/details/systems&platforms.svg";
import ourExpertise from "../../../../Assets/Red_Theme/services/details/ourExpertise.svg";
import circle_svgrepo from "../../../../Assets/Red_Theme/services/details/circle_svgrepo.svg";
import requirementAnalysisNew from "../../../../Assets/Red_Theme/services/details/requirementAnalysisNew.png";
import testPlanningandDesigning from "../../../../Assets/Red_Theme/services/details/testPlanningandDesigning.png";
import bugsReporting from "../../../../Assets/Red_Theme/services/details/bugsReporting.png";
import testExecution from "../../../../Assets/Red_Theme/services/details/testExecution.png";
import qualityProduct from "../../../../Assets/Red_Theme/services/details/qualityProduct.png";
import whyworkwithus from "../../../../Assets/Red_Theme/services/details/whyworkwithus.png";
import whyworkwithus1 from "../../../../Assets/Red_Theme/services/details/whyworkwithus1.png";
import LetDiscuss from "../../../../Components/LetDiscuss";

const QualityAssurance = () => {
  const [isOpen, setOpen] = useState(false);
  const [subject, setSubject] = useState(null);

  const OpenModal = (data) => {
    setSubject(data);
    setOpen(true);
  };

  const ecommerceDevelopmentServices = [
    {
      title: "Cost",
      desc: "Identifying and fixing bugs during the coding stage is six times more cost-effective than addressing them after deployment.",
    },
    {
      title: "Quality",
      desc: "Frequent testing enhances software quality by identifying and fixing bugs, errors, and issues early, preventing them from escalating into major problems.",
    },
    {
      title: "Speed",
      desc: "Automated testing speeds up development, allowing for faster and more efficient code releases.",
    },
    {
      title: "Security",
      desc: "Following strict testing best practices reduces malware risks and ensures your software remains secure and protected.",
    },
    {
      title: "User Experience",
      desc: "Continuous testing evaluates your software’s usability and ensures optimal functionality, improving the overall user experience.",
    },
    {
      title: "Traction",
      desc: "Reliable performance, minimal downtime, and error-free code are key drivers of business success and growth.",
    },
  ];

  const testingPhase = [
    "Functional Testing",
    "Compatibility Testing",
    "Cross-Platform Testing",
    "UI & Usability Testing",
    "Security Testing",
    "Load and Stress Testing",
    "Configuration Testing",
    "Acceptance Testing",
    "Data Migration Testing",
    "Integration Testing",
  ];

  const systemsPlatformsList = [
    "App Testing Services",
    "Web Testing Services",
    "Mobile Testing Services",
    "Desktop Testing",
    "Cloud Solution Testing",
    "Em bedded Systems",
    "IoT Testing",
  ];

  const areasOurExpertise = [
    "QA Consulting",
    "QA Management",
    "QA Documentation",
    "Testing in Agile",
    "Manual Testing",
    "Automation Testing",
    "Full-Cycle Testing",
  ];

  const howItWorks = [
    {
      icon: requirementAnalysisNew,
      title: "Requirement Analysis",
      desc: "We assess your needs and collect critical details to ensure a well-structured system design. Our approach guarantees efficiency and alignment with your business goals.",
    },
    {
      icon: testPlanningandDesigning,
      title: "Test Planning and Designing",
      desc: "We create a strategic plan, define budgets, set timelines, and allocate resources effectively. Our structured approach ensures seamless execution and clear reporting.",
    },
    {
      icon: bugsReporting,
      title: "Bugs Reporting",
      desc: "We ensure product quality using a task management system and advanced bug-tracking tools. Our approach streamlines issue detection and resolution for optimal performance.",
    },
    {
      icon: testExecution,
      title: "Test Execution",
      desc: "We apply the right functional testing techniques combined with automation to ensure accuracy and efficiency. This approach enhances software reliability and performance.",
    },
    {
      icon: qualityProduct,
      title: "Quality Product Delivery",
      desc: "We deliver the finest version of your software by conducting thorough testing and optimizing its quality. Our process ensures a reliable, high-performing product.",
    },
  ];

  return (
    <>
      <section className="qualityAssurance">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <img
                src={qualityAssuranceBanner}
                alt="eCommercePlatformDevelopmentBaner"
                title="eCommercePlatformDevelopmentBaner"
                className="img-fluid w-100"
              />
            </div>
            <div className="col-lg-6">
              <div className="qualityAssuranceTitle">
                <h2>
                  Quality <span>Assurance</span>
                </h2>
                <p>
                  With over a decade of expertise, we specialize in custom
                  eCommerce development, delivering high-performance websites
                  and apps. From optimizing site speed and accessibility to
                  enhancing conversions, integrating third-party tools, and
                  ensuring top-tier security, we build robust solutions tailored
                  to your needs. Let’s create an exceptional shopping experience
                  together.
                </p>
                <button
                  className="theme_btn"
                  onClick={() => OpenModal("Quality Assurance")}
                >
                  <span>Get In Touch</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="eCommerceDevelopmentServices">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="qualityAssuranceTitle">
                <h2>
                  Our eCommerce Development <span>Services</span>
                </h2>
                <p>
                  Our comprehensive quality assurance testing services cover
                  every stage of the software development lifecycle. Partner
                  with a leading software testing company to ensure your product
                  meets both implicit and explicit requirements. We offer
                  automation testing services with full transparency and strict
                  compliance, fostering long-term client relationships through
                  reliable and high-quality solutions.
                </p>
                <button
                  className="theme_btn"
                  onClick={() => OpenModal("Quality Assurance")}
                >
                  <span>Contact with our expert</span>
                </button>
              </div>
            </div>
            <div className="col-lg-6 rightSide">
              {ecommerceDevelopmentServices.map((item, i) => (
                <div className="box" key={i}>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="testingPhase">
        <div className="container">
          <div className="qualityAssuranceTitle">
            <h2>
              Our <span>Testing</span> Phase
            </h2>
            <p>
              We provide full-cycle software testing services for all sorts of
              platforms to improve the quality of your application, lower the
              operational cost, and boost the functionality as well as
              efficiency of your product.
            </p>
          </div>
          <div className="row">
            <div className="col-xl-4 text-center">
              <img
                src={testingPhaseBanner}
                className="img-fluid"
                alt="testingPhaseBanner"
              />
            </div>
            <div className="col-xl-8 rightSide">
              <ul>
                {testingPhase.map((item, i) => (
                  <li key={i}>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="softwareTestingPhase">
        <div className="container">
          <div className="qualityAssuranceTitle">
            <h2>
              Our <span>Software</span> Testing Phase
            </h2>
            <p>
              To ensure minimized time-to-market and reduced risks, our team
              diligently follows agile and scrum-based testing for the best
              quality deliverance of application or software.
            </p>
          </div>
          <div className="boxmain">
            <div className="box">
              <img src={systemsPlatforms} className="img-fluid icon" alt="" />
              <h2>Systems & Platforms</h2>
              <ul>
                {systemsPlatformsList.map((item, i) => (
                  <li key={i}>
                    <img src={circle_svgrepo} className="img-fluid" alt="" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="box">
              <img src={ourExpertise} className="img-fluid icon" alt="" />
              <h2>Areas of Our Expertise</h2>
              <ul>
                {areasOurExpertise.map((item, i) => (
                  <li key={i}>
                    <img src={circle_svgrepo} className="img-fluid" alt="" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="howItWorks">
        <div className="container">
          <div className="qualityAssuranceTitle">
            <h2>
              How It <span>Works</span>
            </h2>
            <p>
              We offer vetted developers with high expertise in delivering high
              quality software development services.
            </p>
          </div>
          <div className="mainbox">
            {howItWorks.map((item, i) => (
              <div className="box" key={i}>
                <div className="heading">
                  <div>
                    <h2>0{i + 1}</h2>
                    <p>{item.title}</p>
                  </div>
                  <img
                    src={item.icon}
                    className="img-fluid"
                    alt="requirementAnalysis"
                  />
                </div>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="whyWorkwithUs">
        <div className="container">
          <div className="qualityAssuranceTitle">
            <h2>
              <span>Why</span> Work with us
            </h2>
            <p>
              As a globally recognized automation software testing company, we
              provide comprehensive testing solutions. From UI and functionality
              to performance, localization, security audits, and advanced test
              automation, we cover it all. Our testing services are built on
              trust and transparency, offering full QA reporting, including test
              coverage, quality assessments, test results, status updates, and
              sign-off reports.
            </p>
          </div>
          <div className="row top">
            <div className="col-lg-6 leftSide">
              <img
                src={whyworkwithus}
                className="img-fluid"
                alt="whyworkwithus"
              />
            </div>
            <div className="col-lg-6 rightSide">
              <h2>Skills of the our Software Testers you hire</h2>
              <ul>
                <li>5+ years in software testing services.</li>
                <li>20+ Different QA Tools and techniques</li>
                <li>Expertise in 5+ key industries and domains</li>
                <li>Successfully delivered 68+ projects</li>
                <li>ISTQB and Cisco-certified experts</li>
                <li>Decrease in time-to-market by at least 23%</li>
                <li>Reduction in total cost of testing by up to 40%</li>
              </ul>
              <button
                className="theme_btn"
                onClick={() => OpenModal("Quality Assurance")}
              >
                <span>Hire QA Tester</span>
              </button>
            </div>
          </div>
          <div className="row bottom">
            <div className="col-lg-6 leftSide">
              <div className="counterList">
                <div className="countBox">
                  <h1>61+</h1>
                  <p>Happy Clients</p>
                </div>
                <div className="countBox">
                  <h1>82+</h1>
                  <p>Project Delivered</p>
                </div>
                <div className="countBox">
                  <h1>20+</h1>
                  <p>Team Members</p>
                </div>
                <div className="countBox">
                  <h1>8+</h1>
                  <p>Years Experience</p>
                </div>
              </div>
              <button
                className="theme_btn"
                onClick={() => OpenModal("Quality Assurance")}
              >
                <span>Request A Free Demo Call</span>
              </button>
            </div>
            <div className="col-lg-6">
              <img
                src={whyworkwithus1}
                className="img-fluid"
                alt="whyworkwithus"
              />
            </div>
          </div>
        </div>
      </section>
      <LetDiscuss />
      {isOpen && (
        <QuoteModal
          open={isOpen}
          setOpen={setOpen}
          CloseModal={() => setOpen(false)}
          subject={subject}
        />
      )}
    </>
  );
};

export default QualityAssurance;
